import { createAsyncThunk } from '@reduxjs/toolkit';

import { buildSpendInsightsBody } from '../lib/buildSpendInsightsBody';

import type {
    SpendFilterSupplierDto,
    SpendInsightsRequestParams,
} from '../types/ReportSpendSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const fetchSpendFilterSuppliers = createAsyncThunk<
    SpendFilterSupplierDto[],
    Omit<SpendInsightsRequestParams, 'supplierIds'>,
    ThunkConfig<string>
>('reportSpendSummary/fetchSpendFilterSuppliers', async (params, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;
    try {
        const response = await extra.api.post<{
            items: SpendFilterSupplierDto[];
        }>(
            '/v1/reports/spend-insights/suppliers',
            buildSpendInsightsBody({
                dateFrom: params.dateFrom,
                dateTo: params.dateTo,
                propertyIds: params.propertyIds,
                categoryIds: params.categoryIds,
            }),
        );
        return response.data.items ?? [];
    } catch {
        return rejectWithValue('error');
    }
});
